export enum GeneralHelpModeConst {
  ACCORDION = 'accordion',
  PLAIN = 'plain'
}
